import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
})
export class SearchBarComponent {
  @Input() placeholder: string = '';
  /** Icono de la izquierda; vacío = lupa Material por defecto. */
  @Input() iconUrl: string = '';
  @Output() searchValueEvent = new EventEmitter<string>();
  @Output() cleanSearchEvent = new EventEmitter<void>();

  isBtnClose = false;
  searchBar = '';
  searchedValue = signal<string>('');

  showCloseIcon() {
    if (this.searchedValue() !== '') this.isBtnClose = true;
  }
  hideCloseIcon() {
    this.isBtnClose = false;
  }

  cleanSearchBar() {
    this.searchBar = '';
    this.searchedValue.set('');
    this.searchValueEvent.emit('');
    this.hideCloseIcon();
    this.cleanSearchEvent.emit();
  }

  cleanBar() {
    this.searchBar = '';
    this.searchedValue.set('');
    this.hideCloseIcon();
  }

  setSearchValue(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    if (value !== '') {
      this.showCloseIcon();
    } else {
      this.hideCloseIcon();
      this.cleanSearchEvent.emit();
    }
    this.searchedValue.set(value);
    this.searchValueEvent.emit(value);
  }

  preventBlur(event: MouseEvent) {
    event.preventDefault();
  }
}
